import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Team from './pages/Team';
import Treatments from './pages/Treatments';
import Prices from './pages/Prices';
import Privacy from './pages/Privacy';
import Clinic from './pages/Clinic';
import Training from './pages/Training';

// Placeholder components for now
const Placeholder = ({ title }) => (
  <div style={{ padding: '4rem', textAlign: 'center' }}>
    <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>{title}</h1>
    <p>Página en construcción. Próximamente disponible.</p>
  </div>
);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="clinica" element={<Clinic />} />
          <Route path="equipo" element={<Team />} />
          <Route path="tratamientos" element={<Treatments />} />
          <Route path="tarifas" element={<Prices />} />
          <Route path="contacto" element={<Contact />} />
          <Route path="formacion" element={<Training />} />
          <Route path="policy" element={<Privacy />} />
          <Route path="cookies" element={<Privacy />} />
          <Route path="*" element={<Placeholder title="404 - No encontrado" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;

